module.exports = __webpack_public_path__ + "static/img/Oak Porcini.2e00a02.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/color/Oak Porcini.jpg
// module id = Posa
// module chunks = 0